import { render, staticRenderFns } from "./ResultsTable.vue?vue&type=template&id=acc24614&scoped=true"
import script from "./ResultsTable.vue?vue&type=script&lang=js"
export * from "./ResultsTable.vue?vue&type=script&lang=js"
import style0 from "./ResultsTable.vue?vue&type=style&index=0&id=acc24614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc24614",
  null
  
)

export default component.exports